import type { ReactNode } from "react";
import React from "react";

interface Props {
	icon?: ReactNode;
	title?: ReactNode;
	variant?: string;
	fill?: boolean;
	firstItem?: boolean;
	lastItem?: boolean;
}

export class TimeLineItem extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { icon, children, title, variant, fill = false, firstItem = false, lastItem = false } = this.props;
		const signItemClassName = `d-flex flex-row justify-content-center align-items-center${
			firstItem ? ` mb-1` : ""
		}${lastItem ? ` mt-1` : ""}`;

		return (
			<div className={`d-flex timeline-item${variant ? ` ${variant}` : ""}`}>
				<div
					className={`d-flex flex-column align-items-center timeline-sign mr-3${
						icon ? "" : " timeline-sign-dot"
					}`}
				>
					{icon ? (
						<div className={`${signItemClassName} timeline-icon`}>{icon}</div>
					) : (
						<div className={`${signItemClassName} timeline-dot`} />
					)}
					<div className={`timeline-line${fill ? " timeline-fill" : ""}`} />
				</div>
				<div className="d-flex flex-column justify-content-center timeline-body">
					{title && <div className="timeline-title">{title}</div>}
					<div>{children}</div>
				</div>
			</div>
		);
	}
}
